import { gql } from 'graphql-request'

export const rateContentMutation = () => gql`
  mutation ($id: String!, $rating: Int!) {
    rateContent(id: $id, rating: $rating) {
      success
      reason
    }
  }
`

